import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Section from './components/Section';
import About from './pages/About';
import News from './pages/News';
import Others from './pages/Others';
import Contact from './pages/Contact';
import './App.css';
import Home from './pages/Home';
const App = () => {
    return (
        <div>
            <BrowserRouter>
                <Navbar />
                    <Routes>
                        <Route path='/' element={<Home />} />
                        <Route path='/News' element={<News />} />
                        <Route path='/About' element={<About />} />
                        <Route path='/Contact' element={<Contact />} />
                        <Route path='/Others' element={<Others />} />
                    </Routes>
            </BrowserRouter>
        </div>
    );
};

export default App;
